import isEmpty from './isEmpty';

// ----------------------------------------------------------------------------

function isEmptyFor(...args: unknown[]): boolean {
    return args.every((item): any => isEmpty(item));
}

// ----------------------------------------------------------------------------

export default isEmptyFor;
